class LocalData {
  static save(key, value) {
    LocalData.saveCookie(key, value)
  }

  static get(key) {
    return LocalData.getCookie(key)
  }

  static saveCookie(key, value) {
    const d = new Date()
    // Expire in 1 day
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000)
    const expires = `expires=${d.toUTCString()}`
    document.cookie = `${key}=${value};${expires};path=/`
  }

  static getCookie(key) {
    const name = `${key}=`
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(";")
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === " ") {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return ""
  }
}

export default LocalData
